export const aciTwoCreditCards = {
    iconName: 'two-credit-cards',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 25' },
        path: [
            {
                attr: {
                    d: 'M22.788 1.5H6.615a2.183 2.183 0 00-2.212 2.212v3.732c0 .415.277.691.691.691.415 0 .692-.415.692-.83h17.832v7.465c0 .415.276.691.69.691.416 0 .692-.276.692-.69V3.71A2.183 2.183 0 0022.788 1.5zM5.786 5.923V3.712c0-.415.414-.83.829-.83h16.173c.415 0 .83.415.83.83v2.211H5.786z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M19.332 9.656H4.265A2.773 2.773 0 001.5 12.421v9.814A2.773 2.773 0 004.265 25h15.067a2.773 2.773 0 002.765-2.765v-9.814a2.773 2.773 0 00-2.765-2.765zM4.265 11.04h15.067c.83 0 1.382.553 1.382 1.382v1.659H2.882v-1.66c0-.829.553-1.381 1.383-1.381zm15.067 12.579H4.265c-.83 0-1.383-.553-1.383-1.383v-6.773h17.832v6.773c0 .83-.69 1.383-1.382 1.383z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M7.306 18.502H5.094c-.414 0-.69.277-.69.692 0 .414.276.69.69.69h2.212c.415 0 .691-.276.691-.69 0-.415-.276-.692-.69-.692zM17.397 17.12c-.83-.276-1.659-.138-2.212.277-.691-.415-1.52-.553-2.212-.277-1.106.415-1.797 1.244-1.797 2.35s.691 2.074 1.797 2.35c.83.277 1.66.139 2.212-.276.415.276.968.415 1.52.415.277 0 .554 0 .83-.139 1.106-.276 1.797-1.244 1.797-2.35-.277-1.105-.968-2.073-1.935-2.35zm-.415 3.456c-.415.138-.968 0-1.244-.415-.138-.138-.277-.276-.553-.276s-.553.138-.691.276c-.277.415-.83.553-1.244.415-.415-.138-.83-.553-.83-1.106s.277-.967.83-1.105c.415-.139.967 0 1.244.414.138.138.276.277.553.277.276 0 .414-.139.553-.277.276-.415.83-.553 1.244-.415.415.139.83.553.83 1.106s-.277.968-.692 1.106z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
